module.exports = __webpack_public_path__ + "ddbd04e0c061ec8be814e7605e46643c.svg";